import { CountResponse, WalletWithAccountId, createBlockWalletMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type BlockWalletModel = ConfirmModalModel<WalletWithAccountId, number, CountResponse>;

export const createBlockWalletModel = (): BlockWalletModel => {
	const blockWalletMutation = createBlockWalletMutation();

	const model = createConfirmModalModel<WalletWithAccountId, number, CountResponse>({
		modalData: declareModalData<WalletWithAccountId>(),
		mapModalData: ({ id }) => id,
		mutation: blockWalletMutation,
		successMessageKey: 'block-wallet.success',
	});

	return model;
};
